import React, { Component } from 'react'
import styles from './styles.scss'

import { TimelineMax, TweenMax, Power3, Expo } from 'gsap'

import Cover from 'src/components/cover-img'

import raf from 'src/utils/raf'
import resize from 'src/utils/resize'
import values from 'src/values'
import config from 'src/config'
import components from 'src/utils/components'

export default class Player extends Component {
  constructor(props) {
    super(props)

    this.key = `playerScreen`
  }

  componentDidMount() {
    this.initTL()
    this.onResize()

    raf.add(this.onRAF)
    resize.add(this.onResize, this.key)
  }

  componentDidUpdate() {
    this.onResize()
  }

  componentWillUnMount() {
    raf.remove(this.raf)
    resize.remove(this.onResize)
  }

  initTL() {
    this.tlRAF = new TimelineMax({
      paused: true
    })

    this.tlRAF.fromTo(
      this.refs.coverContainer,
      1,
      {
        y: '-10%'
      },
      {
        y: '10%'
      },
      0
    )
  }

  onResize = () => {
    if (!this.refs.component) return

    const $component = this.refs.component.getBoundingClientRect()

    this.topComponent = $component.top + values.scroll.currentY
    this.yOffset =
      this.topComponent < values.viewport.height
        ? this.topComponent
        : this.topComponent - values.viewport.height

    this.leftComponent = $component.left
    this.hComponent = this.refs.component.offsetHeight
    this.wComponent = this.refs.component.offsetWidth

    setTimeout(this.addToMenu, 1)

    if (values.viewport.width < config.bp.md && !this.tlRAF.progress()) {
      this.tlRAF.progress(0)
    }
  }

  addToMenu = () => {
    const obj = {
      order: this.props.order,
      legend: this.props.legend,
      top: this.topComponent
    }

    const module =
      values.viewport.width < config.bp.md ? 'homeMenuMobile' : 'homeMenu'

    components.allComponents[module].addItem(obj)
  }

  onRAF = () => {
    if (!this.refs.component || values.viewport.width < config.bp.md) return

    this.perc = (values.scroll.currentY - this.yOffset) / this.hComponent

    if (this.tlRAF && this.perc >= 0) this.tlRAF.progress(this.perc)
  }

  onClick = () => {
    components.allComponents.homePlayer.animateIn()
  }

  render() {
    return (
      <div ref="component" onClick={this.onClick} className="component player">
        <div className="grid-24">
          <div className="grid-16 m-grid-10 content-container">
            <div className="wrapper-content">
              <h1 dangerouslySetInnerHTML={{ __html: this.props.title }} />
              <p>{this.props.content}</p>
              <img
                ref="play"
                className="play"
                src={`${process.env.PUBLIC_URL}/img/player/play.png`}
              />
            </div>
          </div>
        </div>
        <div className="grid-21 m-grid-12 overflow-container">
          <div ref="coverContainer" className="cover-container">
            <Cover
              ref="cover"
              src={`${process.env.PUBLIC_URL}/img/${this.props.cover}`}
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/components/player/index.js